// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"529afd01","213":"8edf4178"}[chunkId] + ".chunk.js";
};